export enum AnimationOption {
  NONE = '',
  BOUNCE = 'animate__bounce',
  FLASH = 'animate__flash',
  PULSE = 'animate__pulse',
  RUBBER_BAND = 'animate__rubberBand',
  SHAKE_X = 'animate__shakeX',
  SHAKE_Y = 'animate__shakeY',
  HEAD_SHAKE = 'animate__shakeY',
  SWING = 'animate__swing',
  TADA = 'animate__tada',
  WOBBLE = 'animate__wobble',
  JELLO = 'animate__jello',
  HEART_BEAT = 'animate__heartBeat',
  BACK_IN_DOWN = 'animate__backInDown',
  BACK_IN_LEFT = 'animate__backInLeft',
  BACK_IN_RIGHT = 'animate__backInRight',
  BACK_IN_UP = 'animate__backInUp',
  BOUNCE_IN = 'animate__bounceIn',
  BOUNCE_IN_DOWN = 'animate__bounceInDown',
  BOUNCE_IN_LEFT = 'animate__bounceInLeft',
  BOUNCE_IN_RIGHT = 'animate__bounceInRight',
  BOUNCE_IN_UP = 'animate__bounceInUp',
  FADE_IN = 'animate__fadeIn',
  FADE_IN_DOWN = 'animate__fadeInDown',
  FADE_IN_LEFT = 'animate__fadeInLeft',
  FADE_IN_RIGHT = 'animate__fadeInRight',
  FADE_IN_UP = 'animate__fadeInUp',
  FLIP = 'animate__flip',
  FLIP_X = 'animate__flipInX',
  FLIP_Y = 'animate__flipInY',
  ZOOM_IN = 'animate__zoomIn',
  ZOOM_IN_DOWN = 'animate__zoomInDown',
  ZOOM_IN_LEFT = 'animate__zoomInLeft',
  ZOOM_IN_RIGHT = 'animate__zoomInRight',
  ZOOM_IN_UP = 'animate__zoomInUp',
  SLIDE_IN_DOWN = 'animate__slideInDown',
  SLIDE_IN_LEFT = 'animate__slideInLeft',
  SLIDE_IN_RIGHT = 'animate__slideInRight',
  SLIDE_IN_UP = 'animate__slideInUp'
}
